import { HelmetProvider } from "react-helmet-async";
import { RouterProvider } from "react-router";
import { AuthProvider } from "./auth/components/auth-provider";
import { rootRouter } from "./common/navigations/root-router";

export function App() {
	return (
		<HelmetProvider>
			<AuthProvider>
				<RouterProvider router={rootRouter} />
			</AuthProvider>
		</HelmetProvider>
	);
}
